<section class="content-section">
  <div style="margin-bottom: 24px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px;">
    <a [routerLink]="'/zone/lister'" class="btn btn-secondary" style="display: inline-flex; align-items: center; gap: 8px;">
      ← Retour à la liste
    </a>
    <div class="mode-badge" [class.view]="!estModeEdition && zoneForm.value.id" [class.edit]="estModeEdition || !zoneForm.value.id">
      <span>{{ (!estModeEdition && zoneForm.value.id) ? '🔒 MODE LECTURE' : '✏️ MODE ÉDITION' }}</span>
    </div>
  </div>

  <!-- VIEW MODE: Read-only display -->
  <ng-container *ngIf="!estModeEdition && zoneForm.value.id">
    <div class="view-mode-container">
      <div class="form-section">
        <h3 class="form-section-title">Informations de la zone</h3>
        <div class="view-item">
          <label class="view-label">Nom de la zone</label>
          <p class="view-value">{{ zoneForm.get('nom')?.value }}</p>
        </div>
        <div class="view-item">
          <label class="view-label">Description</label>
          <p class="view-value" style="white-space: pre-wrap;">{{ zoneForm.get('description')?.value || '—' }}</p>
        </div>
        <div class="view-item">
          <label class="view-label">Ville</label>
          <p class="view-value">{{ nomVille(zoneForm.get('villeId')?.value) }}</p>
        </div>
      </div>

      <div class="form-actions">
        <a [routerLink]="'/zone/lister'" class="btn btn-secondary">Retour</a>
        <button type="button" class="btn btn-primary" (click)="estModeEdition = true">Modifier</button>
      </div>
    </div>
  </ng-container>

  <!-- EDIT MODE: Form -->
  <form class="form-container" [class.edit-mode]="estModeEdition || !zoneForm.value.id" [formGroup]="zoneForm" (ngSubmit)="onSubmit()" *ngIf="estModeEdition || !zoneForm.value.id">
    <div class="form-section">
      <h3 class="form-section-title">Informations de la zone</h3>
      <div class="form-group">
        <label class="form-label">
          Nom de la zone *
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            Nom unique de la zone géographique (ex: "Zone Centre-ville")
          </span>
        </label>
        <input
          type="text"
          class="form-input"
          placeholder="Saisir le nom de la zone ici ..."
          formControlName="nom"
          required>
      </div>
      <div class="form-group">
        <label class="form-label">
          Description
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            Description détaillée de la zone et ses limites géographiques
          </span>
        </label>
        <textarea
          class="form-input"
          placeholder="Saisir la description de la zone ici ...."
          formControlName="description"
          rows="4"></textarea>
      </div>
      <div class="form-group">
        <label class="form-label">
          Ville
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            Ville à laquelle appartient cette zone
          </span>
        </label>
        <select class="form-input" formControlName="villeId">
          <option [ngValue]="null">— Sélectionner une ville —</option>
          <option *ngFor="let v of villes" [ngValue]="v.id">{{ v.nom }}</option>
        </select>
      </div>
    </div>

    <div class="form-actions">
      <a [routerLink]="'/zone/lister'" class="btn btn-secondary">Annuler</a>
      <button type="submit" class="btn btn-primary" [disabled]="chargement">
        {{ chargement ? 'Enregistrement...' : (estModeEdition ? 'Enregistrer les modifications' : 'Enregistrer la zone') }}
      </button>
    </div>

    <app-spinner *ngIf="chargement"></app-spinner>
  </form>
</section>
